import Vue from 'vue'
import enums from './enums'
import behavior from './behavior'

function styleToLowerCase(propertyName) {
  function upperToHyphenLower(match) {
    return '-' + match.toLowerCase();
  }
  return propertyName.replace(/[A-Z]/g, upperToHyphenLower);
}

/**
 * 过滤器工厂
 * @param {Object}
 */
function filterFactory(obj) {
  for (let key of Object.keys(obj)) {
    let filterName = styleToLowerCase(key)
    Vue.filter(filterName, function (val) {
      if (typeof obj[key] === 'object') {
        return obj[key][val]
      } else if (typeof obj[key] === 'function') {
        return obj[key](val)
      } else {
        return '-'
      }
    })
  }
}

filterFactory(enums)
filterFactory(behavior)
